import React, { useState, useEffect, useRef, useContext } from "react";
import { useMutation, useLazyQuery } from "@apollo/client";
// import Uri from "jsuri";
import Fuse from "fuse.js";
import Checkbox from "rc-checkbox";
import Heading from "components/Elements/Heading";
import Loader from "components/Loader/Loader";
import client from "client";
import { QUERY_getPages, LINK_FACEBOOK } from "pages/SourcePage/SourcesQueries";
import { selectIcon } from "components/Utils/Utils.js";
import { SourceContext } from "pages/SourcePage/SourcesMasterPage";

const fuseOptions = {
  shouldSort: true,
  threshold: 0.4,
  location: 0,
  distance: 50,
  maxPatternLength: 12,
  minMatchCharLength: 3,
  keys: ["fb.name", "ig.name"],
};

const SelectAccounts = (props) => {
  const [sidebarClass, setSidebarClass] = useState(props.sidebar);
  const [query, setQueryState] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [
    getPages,
    { data: fbPagesData, loading: loadingFBpages, error: errorFBpages },
  ] = useLazyQuery(QUERY_getPages, { client });

  const node = useRef();

  const catalogData = useContext(SourceContext);

  // const [accountsDelete] = useMutation(DELETE_ACCOUNT, {
  //   client,
  // variables: {
  // tenantID: parseInt(localStorage.defaultTenantID),
  // },
  //   onCompleted(accountsDelete) {
  //     // refetch();
  //   },
  // });

  const [linkFacebbok] = useMutation(LINK_FACEBOOK, {
    client,
    onCompleted(linkFacebbok) {
      // refetch();
    },
  });

  // const uri = new Uri(window.location.href);

  //getting the access_token and calling query
  const hash = window.location.hash.substring(1);
  const params = {};
  hash.split("&").map((hk) => {
    const temp = hk.split("=");
    return (params[temp[0]] = temp[1]);
  });
  const access_token = params.access_token;

  useEffect(() => {
    sendData();
    // refetch();
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendData = async () => {
    if (access_token) {
      getPages({
        variables: {
          fbAccessToken: access_token,
          tenantID: parseInt(localStorage.defaultTenantID),
        },
      });
    }
  };

  const handleEscKey = (e) => {
    if (e.keyCode === 27) {
      setSidebarClass("sidebar close-selected");
      setTimeout(() => {
        props.closeSidebar();
      }, 600);
      setTimeout(() => {
        catalogData.enableSourceButton();
      }, 100);
    }
  };

  const handleClickOutside = (e) => {
    if (
      node.current.contains(e.target) ||
      (catalogData.node.current && catalogData.node.current.contains(e.target))
    )
      return;
    else {
      setSidebarClass("sidebar close-selected");
      setTimeout(() => {
        props.closeSidebar();
      }, 600);
      setTimeout(() => {
        catalogData.enableSourceButton();
      }, 100);
    }
  };

  const closeHandler = (e) => {
    e.preventDefault();
    setSidebarClass("sidebar close-selected");
    setTimeout(() => {
      props.closeSidebar();
    }, 600);
    setTimeout(() => {
      catalogData.enableSourceButton();
    }, 100);
  };

  const fetchData = (id) => {
    if (fbPagesData) {
      const onCompleted = (fbPagesData) => {
        linkFacebbok({
          variables: {
            sessionID: fbPagesData.getUserFacebookPages.sessionID,
            pageIDs: id,
          },
        });
        setSidebarClass("sidebar close-selected");
        setTimeout(() => {
          props.closeSidebar();
        }, 600);
      };
      const onError = (error) => {
        return <div>{error}</div>;
      };
      if (onCompleted || onError) {
        onCompleted &&
          !loadingFBpages &&
          !errorFBpages &&
          onCompleted(fbPagesData);
        onError && !loadingFBpages && errorFBpages && onError(errorFBpages);
      }
    }
  };

  const onChange = (e) => {
    let ID = e.target.id;
    e.target.checked ? addItem(ID) : removeItem(ID);
  };

  const addItem = (item) => {
    setAllAccounts([...allAccounts.filter((i) => i !== fbPagesData), item]);
  };

  const removeItem = (item) => {
    const ACCOUNTS = allAccounts.filter((i) => i !== item);
    setAllAccounts(ACCOUNTS.length === 0 ? [] : ACCOUNTS);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchData(allAccounts);
  };

  const onChangeAll = (e) => {
    let selectedID = fbPagesData.getUserFacebookPages.data
      .filter((el) => el.linked === "false")
      .map((el) => el.fb.id);
    e.target.checked ? setAllAccounts(selectedID) : setAllAccounts([]);
  };

  const handleSearch = (e) => {
    setQueryState(e.target.value);
  };

  const renderAccounts = () => {
    if (fbPagesData) {
      const fuse = new Fuse(fbPagesData.getUserFacebookPages.data, fuseOptions);
      const searchData = query
        ? fuse.search(query)
        : fbPagesData.getUserFacebookPages.data;

      if (searchData.length === 0) {
        return (
          <div className="col-12 d-flex flex-column align-items-center">
            <Heading size={5} className={"mt-5"}>
              No sources found
            </Heading>
          </div>
        );
      } else {
        return (
          <>
            <Heading size={5} className="pt-2 font-weight-bold">
              Facebook Pages ({allAccounts.length} of {searchData.length}{" "}
              selected)
            </Heading>
            <div className="mt-2 d-flex flex-column account-list">
              {searchData.map((item) => (
                <label key={item.fb.id} className=" custom-checkbox">
                  <Checkbox
                    id={item.fb.id}
                    checked={
                      allAccounts.includes(item.fb.id) || item.linked === "true"
                    }
                    onChange={onChange}
                  />
                  <span className="pl-2">{item.fb.name}</span>
                </label>
              ))}
            </div>

            <Heading size={5} className="pt-4 font-weight-bold">
              Instagram Accounts
            </Heading>
            <div className="mt-2 d-flex flex-column account-list">
              {searchData.map((item, i) => (
                <span className="pl-4" key={i}>
                  {item.ig.name}
                </span>
              ))}
            </div>
          </>
        );
      }
    }
  };

  return (
    <div ref={node}>
      <div className={sidebarClass}>
        <header className="source-header p-3">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <img
                  src={selectIcon(props.sourceData.type)}
                  alt={props.sourceData.type}
                  width="40"
                  height="40"
                />
                <div>
                  <Heading size={4} className="m-2">
                    {props.sourceData.name}
                  </Heading>
                </div>
              </div>
            </div>
            <div className="col-6 py-2 text-right">
              <button
                type="button"
                className="close-selected"
                onClick={closeHandler}
              >
                &times;
              </button>
            </div>
          </div>
        </header>

        <div className="account-container">
          <Heading size={5} className="p-3 font-weight-bold">
            Select Accounts To Connect
          </Heading>
          <form className="row px-4" onSubmit={handleFormSubmit}>
            <div className="col-6 p-3 mb-2" style={{ background: "#f3f4f5" }}>
              <div className="col-2">
                <div style={{ position: "relative" }}>
                  <div className="form-group ml-2 mr-2">
                    <input
                      placeholder="Search For"
                      onChange={(e) => handleSearch(e)}
                      style={{ fontSize: "0.7rem" }}
                      className="sources-border-between"
                    />
                  </div>
                </div>
              </div>
              <label className="account-list custom-checkbox">
                <Checkbox name="all" onChange={onChangeAll} />
                <span className="pl-2">Select All</span>
              </label>
              <small
                className="font-weight-bold mb-2"
                style={{ color: "#343a40" }}
              ></small>
              {loadingFBpages ? (
                <Loader minHeight={200} col={"col-1"} size="circle-scale--sm" />
              ) : (
                renderAccounts()
              )}
            </div>
            <div className="col-6 px-5">
              <p>
                Select from the list to the left all the accounts you’d like to
                pull into this project space.
              </p>
              <p>
                Data from these accounts will start getting pulled into Pickaxe
                immediately, but it may take a few days for the entire set of
                data to sync, depending on how much there is.
              </p>
              <small className="font-weight-bold">
                {allAccounts.length} Accounts Selected
              </small>
              <div className="mt-2">
                <button
                  type="button"
                  className="add-source-button mr-3"
                  onClick={handleFormSubmit}
                >
                  <i className="fas fa-plus plus-sign mr-2" />
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default SelectAccounts;
